<template>
  <div class="scrollableY">
      

        <div id="settsBar" class="settingsMenu settsOpen has-text-white" ref="bar">
            <div class="handCursor settsArrow"  @click="toggleOpen"><i :class="{'fa fa-chevron-left': menuOpen, 'fa fa-chevron-right' : !menuOpen, 'arrowAdj' : !menuOpen}"></i></div>
            
            <div class="top40">
               
                <div class="settingsItem" :class="{selected: comp == 'about'}" @click="loadItem('about')" >ABOUT US</div>
                <div class="settingsItem" :class="{selected: comp == 'faq'}" @click="loadItem('faq')" >FAQ</div>
                <div class="settingsItem " :class="{selected: comp == 'help'}" @click="loadItem('help')" >HELP</div>
                <div class="infoPagItemBotBorder"></div>
                <!-- <div class="settingsItem top30" :class="{selected: comp == ''}">WHAT'S NEW</div>
                <div class="settingsItem top30" :class="{selected: comp == ''}">COMING SOON</div> -->
                <!-- <div class="settingsItem top40" :class="{selected: comp == 'press'}" @click="loadItem('press')">PRESS</div> -->
                <div class="settingsItem top40" :class="{selected: comp == 'newsroom'}" @click="loadItem('newsroom')">NEWSROOM</div>
                <div class="settingsItem top30" :class="{selected: comp == ''}">PARTNERS</div>
                <div class="settingsItem top30" :class="{selected: comp == ''}">ADVERTISING</div>
                <div class="settingsItem" :class="{selected: comp == 'terms'}" @click="loadItem('terms')" >TERMS</div>
                <div class="settingsItem" :class="{selected: comp == 'privacy'}" @click="loadItem('privacy')" >PRIVACY</div>
                <div class="settingsItem" :class="{selected: comp == 'contact'}" @click="loadItem('contact')" >CONTACT US</div>
            </div>
          </div >
            
     

       <div class="settingsContent posRelative">
            <div v-show="!staticPage" class="container top40 paddingInInfo" ref="theContent">
                <div v-for="(item, i) in source" :key="i">
                    <component :is="item.comp" :params="item.params" :index="i"></component>
                </div>
            </div>

            <div v-if="staticPage" class="settingsContent posRelative"> 
                <component :is="comp" :id="id" ref="main"></component>
            </div>
       </div>
       <!-- <div id="spinner" class="top160 bottom40"></div> -->
       <footerdiv ></footerdiv>
  </div>

</template>

<script>

import { AZEventBus } from '../components/AZEventBus'
import titleSection from '../components/cms/titleSection.vue'
import subTitleSection from '../components/cms/subTitleSection.vue'
import threeColumns from '../components/cms/threeColumns.vue'
import fourColumns from '../components/cms/fourColumns.vue'
import paragraph from '../components/cms/paragraph.vue'
import imageAndText from '../components/cms/imageAndText.vue'
import divider1 from '../components/cms/divider1.vue'
import searchBundles from '../components/SearchPBundles.vue'
import threeAds from '../components/cms/threeAds.vue'
import Footerdiv from '../components/Footer.vue'
import bundleComplete from '../components/cms/bundleComplete.vue'
import contact from '../components/SettsContact.vue'
import faq from '../components/cms/cmsFaq.vue'
import terms from '../components/SettsTerms.vue'
import privacy from '../components/SettsPrivacy.vue'
import help from '../components/SettsHelp.vue'

export default {
    components: {titleSection, subTitleSection, threeColumns, paragraph, imageAndText, divider1, fourColumns, threeAds, Footerdiv, bundleComplete, searchBundles, contact, faq, terms, privacy, help},
    props: ['section','id'],
    data: function(){
        return {
            inited: false,
            source: [],
            done: false,
            menuOpen: true,
            staticPage: false,
            comp: 'about'
        }
    },

    mounted: function(){
        var self = this

        function w(d){
            az.addRemSpinner(false, 'id', 'spinner')
      
            if(d == 'notFound') 
                self.$router.push('/p404')

            if(d.isLive){
                self.source = JSON.parse(d.source)
                self.done = true

            } else {
                self.$router.push('/p404')
            }
        }

        function n(){
            az.addRemSpinner(false, 'id', 'spinner')
        }


        function init(){
            

            if(!self.id || self.id == 'about'){
                self.loadItem('about', true)
            } 

            /* if(!self.staticPage){
                az.addRemSpinner(true, 'id', 'spinner')
                self.$root.app.apiClient.get('open/confirm/onepage/' + self.id, {}, w, n)
            }  */
           self.loadItem(self.section, true)
            
        }

        if(self.$root.app.doneFederating){
           init();
        }

        AZEventBus.$once('onFederate', msg => {
            init();
        });
        
    },

    methods: {
        toggleOpen: function(){
          if(this.menuOpen){
            this.$refs.bar.style.left = '-190px'
            this.$refs.theContent.style['padding-left'] = '30px'
            this.menuOpen = false
          } else {
            this.$refs.bar.style.left = '0px'
            this.menuOpen = true
          }
      },

      updUrl: function(){
        var self = this;
        var theId = ''
        if(this.comp == 'help' && this.id != process.env.VUE_APP_ROOT_HELP)
            theId += '/' +this.id
        history.replaceState(
            {},
            null,
            '/info/' + this.comp + theId
        )
      },

      loadItem: function(id, firstLoad){
        var self = this;
        
        if(this.menuOpen && !firstLoad){
            this.toggleOpen()
        }

        if(id == 'about'){
            this.id = 'about' //process.env.VUE_APP_ROOT_ABOUT
            this.staticPage = false
            this.comp = 'about'
            this.updUrl()
        } else if(id == 'press'){
            this.id = 'press' //process.env.VUE_APP_ROOT_PRESS
            this.staticPage = false
            this.comp = 'press'
            this.updUrl()
        } else if(id == 'newsroom'){
            this.id = 'newsroom' //process.env.VUE_APP_ROOT_NEWSROOM
            this.staticPage = false
            this.comp = 'newsroom'
            this.updUrl()
        } else if(id == 'faq'){
            this.id = 'faq' //process.env.VUE_APP_ROOT_FAQ
            this.staticPage = false
            this.comp = 'faq'
            this.updUrl()
        } else if(id == 'help'){
            this.$route.params.id ? this.id = this.$route.params.id : this.id = 'help'
            this.staticPage = true
            this.comp = 'help'
            this.updUrl(this.id)
        } else if(id == 'contact'){
            this.staticPage = true
            this.comp = 'contact'
            this.updUrl()
        } else if(id == 'terms'){
            this.staticPage = true
            this.comp = 'terms'
            this.updUrl()
        } else if(id == 'privacy'){
            this.staticPage = true
            this.comp = 'privacy'
            this.updUrl()
        } 
        

        function w(d){
            az.addRemSpinner(false, 'id', 'spinner')
      
            if(d == 'notFound') 
                self.$router.push('/p404')

            if(d.isLive){
                self.source = JSON.parse(d.source)
                self.done = true

            } else {
                self.$router.push('/p404')
            }
        }

        function n(){
            az.addRemSpinner(false, 'id', 'spinner')
        }

        if(!this.staticPage){
            az.addRemSpinner(true, 'id', 'spinner')
            self.$root.app.apiClient.get('open/confirm/onepage/' + self.id, {}, w, n)
        }

      }
    }

}



</script>